import { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../../reducers";

import DeleteIcon from '../../../../media/felsv/dark_recyclebin_icon.svg'
import EditIcon from '../../../../media/felsv/PenEdit.svg'
import DolarIcon from '../../../../media/felsv/Dollar.svg'
import PorcentageIcon from '../../../../media/felsv/Porcentaje.svg'
import HelpIcon from '../../../../media/felsv/help-circle-svgrepo-com.svg';

import BasicCardDocumentos from "../BasicCardDocumentos";
import InputForm from "../InputFormV2";
import SwitchTipoProductoDTE from "../BasicSwitchTipoProducto";
import { Pagination } from "../../../../components/Pagination";

import { actionGeneral, actionsLogin } from "../../../../actions/action-creators";
import { BannerElegirSucursal } from "../../../../components/Banner/BannerElegirSucursal";
import DocumentosReceptor from "../../../../components/DocumentoReceptor/DocumentosReceptor";
import useNotaDebitoExterno from "../../../../actions/nota-debito-externo.actions";
import { DocFisico } from "../../../../interfaces/general.interface";
import ModalDocFisicos from "../../../../components/Modals/DocumentoFisico/ModalDocFisicos";
import { getFechaCA } from "../../../../utils/stringDate";
import { convertirNumeroConComas } from "../../../../utils/numbers.utils";
import InputChips from "../InputChips";
import { Tooltip } from "../../../../components/Tooltip/Tooltip";
import { esCatalogoProductoByTipo, processDetalleImpuestosHTML } from "../../../../actions/utils-documentos.actions";
import InputSwitchDescripcion, { CheckBoxFlag } from "../InputSwitchDescripcion";

export default function FormulariosNDExterno (){
    const {fecha_actual} = useSelector((state: State) => state.general)
    const {formCliente, errorsCliente, formProducto, errorsProducto, modal_documentoFisico, documentosFisico, calculosProducto, productos, totalOriginal} = useSelector((state: State) => state.notaDebitoExterno)
    const {departamentos, municipios, actividadesEconomicas, tipoDocumentosEmision, condicionOperacion, datosEmisor, unidadesMedida, productos: productosCatalogo} = useSelector((state: State) => state.catalogos)
    
    const [customDescripcion, setCustomDescripcion] = useState(false);
    const [checkTextoEnrequecido, setCheckTextoEnrequecido] = useState(false);

    const dispatch = useDispatch();
    const {suscripcionGetFacturasDisponibles} = bindActionCreators(actionsLogin, dispatch)
    const {getFechaHora, validateHorarioSucursal, validateUsoModulo} = bindActionCreators(actionGeneral, dispatch)
    
    const {
        onChangeFormCliente,
        onChangeFormProducto,
        onChangeSelectCatalogoProducto,
        cargarDatosIniciales,
        buscarCliente,

        button_onClickAgregarProducto,
        button_onClickLimpiarFormProducto,

        validateFormCliente,
        validateFormProducto,

        actionButton_editar,
        actionButton_eliminarProducto,

        cargarSucursales,
        calculosProductos,

        modal_ShowModalDocumento,
        guardarDocumentoFisico,
    } = useNotaDebitoExterno()
    
    const handleChangeFormCliente = (e: any) => {
        onChangeFormCliente(e.target.name, e.target.value)
    }
    const handleChangeFormProducto = (e: any) => {
        onChangeFormProducto(e.target.name, e.target.value)
        if (e.target.name === "descripcion" && e.target.value === "") {setCustomDescripcion(false)}
    }
    const handleSelectCatalogoProducto = (e: any) => {
        if (e.label != -1) onChangeSelectCatalogoProducto(e.value);
        else {
            setCustomDescripcion(true);
            setCheckTextoEnrequecido(false);
            onChangeFormProducto('descripcion', e.value, {clave: '', tributos: []});
        }
    }
    const handleBlurFormCliente = async(e: any) => {
        validateFormCliente(e.target.name, e.target.value)
        if(e.target.name === 'noDocumento') await buscarCliente()
    }

    const handleBlurFormProducto = (e: any) => {
        validateFormProducto(e.target.name, e.target.value)
    }

    useEffect(() => {
        validateUsoModulo()
        validateHorarioSucursal()
        suscripcionGetFacturasDisponibles()
        cargarSucursales()
        cargarDatosIniciales()
        getFechaHora();
    }, [])

    const [tableProductos, setTableProductos] = useState(productos)
    useEffect(() => {
        setTableProductos(productos);
    }, [productos])

    return(
      <>
        <BannerElegirSucursal />
        {modal_documentoFisico && <ModalDocFisicos idTipoDoc={["03"]} documentoEdit={documentosFisico.tipo ? documentosFisico : null} onClicCerrar={() => {modal_ShowModalDocumento(false)}} onClicAgregar={(documento: DocFisico) => {guardarDocumentoFisico(documento)}}/>}
        <div className="otros-documentos-container">
            <div className="w-layout-layout bill-section wf-layout-layout">
                    <BasicCardDocumentos title="Documento físico">
                        <div className="w-100">
                            <button className='m button' style={{width:"auto", borderRadius: "50px"}} onClick={() => {modal_ShowModalDocumento(true)}} >{documentosFisico.tipo ? "Editar" : "Agregar"} documento físico</button>
                        </div>
                        <div className="w-100">
                            <div className='tab-plane mt-16' style={{overflowX: 'auto'}}>
                                <table className='tlu-table-main-responsive tlu-responsive-table-main td-left table-pointer'>
                                <thead>
                                    <tr>
                                        <td>Número de documento</td>
                                        <td>Tipo de documento</td>
                                        <td>Fecha de generación</td>
                                        <td>Monto</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {documentosFisico.numId && <tr>
                                        <td data-label='Número de documento'>{documentosFisico.numId}</td>
                                        <td data-label='Tipo de documento'>{tipoDocumentosEmision?.find((tipo) => tipo.codigodocumento === documentosFisico.tipo)?.nombre}</td>
                                        <td data-label='Fecha de generación'>{getFechaCA(documentosFisico.fecha)}</td>
                                        <td data-label='Monto'>${convertirNumeroConComas(documentosFisico.monto)}</td>
                                    </tr>}
                                </tbody>
                                </table>
                            </div>
                        </div>
                    </BasicCardDocumentos>
            </div>
            <div className='dos-columnas-resp'>
                <div className='form-content'>
                    <BasicCardDocumentos title="Datos del cliente">
                        <InputForm required name = 'granContribuyente' label = 'Gran contribuyente' type = 'checkbox' value = {formCliente.granContribuyente} onChange = {(e: any) => onChangeFormCliente('granContribuyente', !formCliente.granContribuyente)}/>
                        <div className='w-layout-hflex h-inputs'>
                            <InputForm name = 'fecha' placeholder = 'Fecha de emisión' label = 'Fecha' type = 'date' value = {fecha_actual?.FechaInput} error = {errorsCliente.fecha}/>
                            <InputForm onBlur = {handleBlurFormCliente} required name = 'noDocumento' placeholder = 'NIT' label = 'NIT' type = 'text' value = {formCliente.noDocumento} error = {errorsCliente.noDocumento} onChange = {handleChangeFormCliente}/>
                        </div>
                        <div className='w-layout-hflex h-inputs'>
                            <InputForm maxLength = {50} onBlur = {handleBlurFormCliente} required name = 'nombre' placeholder = 'Nombre' label = 'Nombre' type = 'text' value = {formCliente.nombre} error = {errorsCliente.nombre} onChange = {handleChangeFormCliente}/>
                        </div>
                        <div className='w-layout-hflex h-inputs'>
                            <InputForm required options = {departamentos?.map((dep) => ({...dep, codigo_nombre: `${dep.codigo} - ${dep.valor}`}))} keyNameText = 'codigo_nombre' keyNameValue = 'codigo' name = 'departamento' placeholder = 'Departamento' label = 'Departamento' type = 'select' value = {formCliente.departamento} error = {errorsCliente.departamento} onChange = {(e: any) => onChangeFormCliente('departamento', e.value)}/>
                            <InputForm required options = {municipios?.map((mun) => ({...mun, codigo_nombre: `${mun?.codigo} - ${mun?.valor}`}))} keyNameText = 'codigo_nombre' keyNameValue = 'codigo' name = 'municipio' placeholder = 'Municipio' label = 'Municipio' type = 'select' value = {formCliente.municipio} error = {errorsCliente.municipio} onChange = {(e: any) => onChangeFormCliente('municipio', e.value)}/>
                        </div>
                        <div className='w-layout-hflex h-inputs'>
                            <InputForm maxLength = {60} onBlur = {handleBlurFormCliente} required name = 'direccion' placeholder = 'Dirección' label = 'Dirección' type = 'text' value = {formCliente.direccion} error = {errorsCliente.direccion} onChange = {handleChangeFormCliente}/>
                        </div>
                        <div className='w-layout-hflex h-inputs'>
                            <InputChips maxChips={5} chips={formCliente.chipsEmail} setChips={(chipsEmail: Array<string>) => onChangeFormCliente('chipsEmail', chipsEmail)} maxLength = {50} onBlur = {handleBlurFormCliente} required name = 'email' placeholder = 'Correo electrónico' label = 'Correo electrónico' type = 'text' value = {formCliente.email} error = {errorsCliente.email} onChange = {handleChangeFormCliente}/>
                            {/* <InputForm maxLength = {50} onBlur = {handleBlurFormCliente} required name = 'email' placeholder = 'Correo electrónico' label = 'Correo electrónico' type = 'text' value = {formCliente.email} error = {errorsCliente.email} onChange = {handleChangeFormCliente}/> */}
                        </div>
                        <div className='w-layout-hflex h-inputs'>
                            <InputForm required options = {actividadesEconomicas.map((act) => ({...act, codigo_valor: `${act.codigo}-${act.valor}`}))} keyNameText = 'codigo_valor' keyNameValue = 'codigo' name = 'actividad' placeholder = 'Actividad económica' label = 'Actividad económica' type = 'select' value = {formCliente.actividad} error = {errorsCliente.actividad} onChange = {(e: any) => onChangeFormCliente('actividad', e.value)}/>
                            <InputForm onBlur = {handleBlurFormCliente} required name = 'telefono' placeholder = 'Teléfono celular' label = 'Teléfono celular' type = 'phone' value = {formCliente.telefono} error = {errorsCliente.telefono} onChange = {(phone: any) => onChangeFormCliente('telefono', phone)}/>
                        </div>
                        <div className='w-layout-hflex h-inputs'>
                            <div className='label-input'>
                            <InputForm maxLength = {14} onBlur = {handleBlurFormCliente} required name = 'nrc' placeholder = 'NRC' label = 'NRC' type = 'text' value = {formCliente.nrc} error = {errorsCliente.nrc} onChange = {handleChangeFormCliente}/>
                            </div><div className='label-input'></div>
                        </div>
                    </BasicCardDocumentos>
                </div> 
                <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
                    <BasicCardDocumentos title="Sucursal y serie">
                        <div className='w-layout-hflex h-inputs'>
                            <InputForm disabled={true} required options = {formCliente?.datosSucursal} keyNameText = 'nombre' keyNameValue = 'idsucursal' name = 'sucursal' placeholder = 'Sucursal' label = 'Sucursal' type = 'select' value = {formCliente.sucursal} error = {errorsCliente.sucursal} onChange = {(e: any) => onChangeFormCliente('sucursal', e.value)}/>
                            <InputForm disabled={!formCliente.loadedSucursal} required options = {formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente?.sucursal)?.Documento?.map((doc: any) => ({...doc, serie_numero: `${doc.serie}-${doc.numeroactual}`}))} keyNameText = 'serie_numero' keyNameValue = 'idsucursaldocumento' name = 'serie' placeholder = 'Serie' label = 'Serie' type = 'select' value = {formCliente.serie} error = {errorsCliente.serie} onChange = {(e: any) => onChangeFormCliente('serie', e.value)}/>
                        </div>
                        <div><h3 className="card-title">Producto o Servicio</h3></div>
                        <hr className="separador"/>
                        <SwitchTipoProductoDTE producto = {!formProducto.servicio} setProducto = {() => onChangeFormProducto('servicio', false)} setServicio = {() => onChangeFormProducto('servicio', true)}/>
                        <div className="cf-row-inputs">
                          <InputForm required name = 'descripcion' label = 'Exento' type = 'checkbox' value = {formProducto.exento} onChange = {(e: any) => onChangeFormProducto('exento', !formProducto.exento)}/>
                          <InputForm required name = 'descripcion' label = 'Incluye IVA' type = 'checkbox' value = {formProducto.conIva} onChange = {(e: any) => onChangeFormProducto('conIva', !formProducto.conIva)}/>
                        </div>
                        {!formProducto.exento &&
                            <p style={{color: '#019FC5'}}>Nota: Este {formProducto.servicio ? 'servicio' : 'producto'} lleva un 13% extra por concepto de IVA. ( {formProducto.servicio ? 'Servicio' : 'Producto'} gravado)</p>
                        }
                        {
                            (!customDescripcion && productosCatalogo.length > 0)
                            ? 
                                <InputForm 
                                    enableCreate={true} required 
                                    label = 'Descripción' type = 'select' 
                                    options = {productosCatalogo.filter((prod) => esCatalogoProductoByTipo(formProducto.servicio, prod))} 
                                    keyNameText = 'descripcion' keyNameValue = 'clave' 
                                    onChange = {handleSelectCatalogoProducto}  
                                    value = {formProducto.clave} error = {errorsProducto.descripcion}
                                    componentSideLabel = {
                                        <CheckBoxFlag
                                          label="Activar texto con formato" 
                                          value={customDescripcion} 
                                          onChange={() => {
                                            setCustomDescripcion(true);
                                            setCheckTextoEnrequecido(true);
                                          }}
                                        />
                                    }
                                />
                            : (
                                <div className="w-layout-hflex h-inputs">
                                    <InputSwitchDescripcion defaultEnrequecido={checkTextoEnrequecido} className='m text-field w-input' maxLength = {1000} onBlur = {handleBlurFormProducto} required name = 'descripcion' placeholder = 'Descripción' label = 'Descripción' type = 'text' value = {formProducto.descripcion} error = {errorsProducto.descripcion} onChange = {handleChangeFormProducto}/>    
                                </div>
                            )
                        }
                        <div style={{flexDirection: "row"}} >
                            <div className={`ef-form-producto-div4`}>
                                <div className='label-input'>
                                    <InputForm maxLength = {15} onBlur = {handleBlurFormProducto} required name = 'cantidad' placeholder = '0' label = 'Cantidad' type = 'text' value = {formProducto.cantidad} error = {errorsProducto.cantidad} onChange = {handleChangeFormProducto}/>
                                </div>
                                <div className='label-input'>
                                <InputForm type = 'select' options = {unidadesMedida} keyNameText = 'valor' keyNameValue = 'codigo' onChange = {(e: any) => onChangeFormProducto('unidadMedida', e.value)} label = 'Unidad de medida' value = {formProducto.unidadMedida}/>
                                </div>
                                <div className='label-input'>
                                    <InputForm maxLength = {15} onBlur = {handleBlurFormProducto} required name = 'precio' placeholder = '$0.00' label = 'Precio' type = 'text' value = {formProducto.precio} error = {errorsProducto.precio} onChange = {handleChangeFormProducto}/>
                                </div>
                                <div className='label-input'>
                                <InputForm options = {[{nombre: 'Porcentaje'}, {nombre: 'Monto'}]} keyNameText = 'nombre' keyNameValue = 'nombre' name = 'tipoDescuento' placeholder = 'Tipo de descuento' label = 'Tipo de desc.' type = 'select' value = {formProducto.tipoDescuento} error = {null} onChange = {(e: any) => onChangeFormProducto('tipoDescuento', e.value)}/>
                                </div>
                                <div className='label-input'>
                                    <InputForm 
                                        maxLength = {formProducto.tipoDescuento === 'Porcentaje' ? 6 : 15}
                                        leftIcon = {formProducto.tipoDescuento === 'Porcentaje' ? PorcentageIcon : DolarIcon}
                                        type = 'text'
                                        value = {formProducto.descuento}
                                        name = 'descuento'
                                        onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                                        placeholder = '0.00'
                                        label = 'Descuento'
                                        error = {errorsProducto.descuento}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="cf-calculos-producto">
                            <table>
                                <tbody>
                                    <tr className="cf-subtotal">
                                        <td>Valor bruto</td>
                                        <td>{calculosProducto?.neto}</td>
                                    </tr>
                                    <tr className="cf-descuento">
                                        <td>Descuento</td>
                                        <td>{calculosProducto?.descuento}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>Subtotal</td>
                                        <td>{calculosProducto?.subtotal}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>Impuesto al Valor Agregado 13%
                                        </td>
                                        <td>{calculosProducto?.iva}</td>
                                    </tr>
                                    <tr className="cf-subtotal opacity-full-gray">
                                        <td>
                                            <Tooltip content='Cálculo de impuestos aplica en el resumen'>
                                                <button className='table-action no-background'>
                                                    <img src={HelpIcon} className='help-icon-button' />
                                                </button>
                                            </Tooltip>
                                            Otros impuestos
                                        </td>
                                        <td>{calculosProducto?.otrosImpuestos}</td>
                                    </tr>
                                    <tr className="cf-total">
                                        <td>Total</td>
                                        <td>{calculosProducto?.total}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="w-layout-hflex button-actions">
                                <button className="button transparent" onClick={() => {button_onClickLimpiarFormProducto(); setCustomDescripcion(false)}}>Limpiar</button>
                                <button className="button" onClick={() => {button_onClickAgregarProducto(); setCustomDescripcion(false)}}>Agregar</button>
                            </div>
                        </div>
                    </BasicCardDocumentos>
                </div>
            </div>
            <div className="w-100">
                <div className="w-layout-layout bill-section wf-layout-layout">
                    <BasicCardDocumentos title="Detalle de productos o servicios" style={{maxWidth: '100%', boxShadow: "none"}}>
                        <div className="tab-plane">
                            <div style={{overflowX: "auto"}}>
                            <div className="table-facturacion-resp">
                                <table className="table-main-responsive responsive-table-main td-left table-pointer">
                                    <thead>
                                        <tr>
                                            <td>Cantidad</td>
                                            <td>Unidad de medida</td>
                                            <td>Tipo</td>
                                            <td>Descripción</td>
                                            <td>Precio unitario</td>
                                            <td>Descuento</td>
                                            <td>Ventas gravadas</td>
                                            <td>Ventas exentas</td>
                                            <td>Acciones</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableProductos.map((producto, index) => {
                                            let precioUnitario = 0
                                            let descuento = 0
                                            let gravadas = 0
                                            let exentas = 0
                                            let detalleTributos = ''

                                            precioUnitario = producto.conIva ? parseFloat((parseFloat(producto.precio)/1.13).toFixed(2)) : parseFloat(parseFloat(producto.precio).toFixed(2))
                                            descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (parseFloat(producto.descuento)/100*precioUnitario) * parseFloat(producto.cantidad) : parseFloat(producto.descuento) 
                                            gravadas = (precioUnitario * parseFloat(producto.cantidad)) - descuento
                                            exentas = (precioUnitario * parseFloat(producto.cantidad)) - descuento  
                                            detalleTributos = processDetalleImpuestosHTML(productosCatalogo, '06', producto, gravadas);

                                            return(
                                            <tr key={index}>
                                                <td data-label="Cantidad">{producto.cantidad}</td>
                                                <td data-label="Unidad de medida">{unidadesMedida.find((unidad) => unidad.codigo === producto.unidadMedida)?.valor}</td>
                                                <td data-label="Tipo">{`${producto.servicio ? 'Servicio' : 'Producto'} ${producto.exento ? ' exento' : ''}`}</td>
                                                <td data-label="Descripción" style={{wordBreak:"break-all"}}>{<div dangerouslySetInnerHTML={{ __html: producto.descripcion }} />}</td>
                                                <td data-label="Precio unitario">{precioUnitario.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                                <td data-label="Otros impuestos"><div dangerouslySetInnerHTML={{ __html: detalleTributos }} /></td>
                                                <td data-label="Descuento">{isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                                <td data-label="Ventas gravadas">{!producto.exento ? (isNaN(gravadas) ? '$0.00' : gravadas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})): '$0.00'}</td>
                                                <td data-label="Ventas exentas">{producto.exento ? (isNaN(exentas) ? '$0.00' : exentas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})): '$0.00'}</td>
                                                <td data-label="Acciones">
                                                    <button onClick={() => actionButton_editar(producto)}><img src={EditIcon} alt="edit"/></button>
                                                    <button onClick={() => actionButton_eliminarProducto(producto.id)}><img src={DeleteIcon} alt="delete"/></button>
                                                </td>
                                            </tr>
                                        )})}
                                    </tbody>
                                </table>
                            </div>
                            </div>
                            <Pagination data = {productos} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                            {/* <InputForm required name = 'granContribuyente' label = 'No realizar retención renta' type = 'checkbox' value = {retencionRenta} onChange = {(e: any) => handleChangeRetencionRenta()}/> */}
                            <div className="cf-calculos-producto">
                                <table>
                                    <tbody>
                                        <tr className="cf-subtotal">
                                            <td>Suma de operaciones</td>
                                            <td>{calculosProductos().sumaOperaciones.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        </tr>
                                        <tr className="cf-subtotal">
                                            <td>Impuesto al Valor Agregado 13%</td>
                                            <td>{calculosProductos().iva.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        </tr>
                                        <tr className="cf-subtotal">
                                            <td>Otros impuestos
                                            </td>
                                            <td>{calculosProductos().otrosImpuestos.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        </tr>
                                        <tr className="cf-subtotal">
                                            <td>Subtotal</td>
                                            <td>{(calculosProductos().subtotal).toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        </tr>
                                        <tr className="cf-subtotal">
                                            <td>IVA percibido 1%</td>
                                            <td>{calculosProductos().ivaPercibido.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        </tr>
                                        <tr className="cf-subtotal">
                                            <td>IVA retenido 1%</td>
                                            <td>{calculosProductos().ivaRetenido.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        </tr>
                                        <tr className="cf-descuento">
                                            <td>Retencion renta 10%</td>
                                            <td>{calculosProductos().retencionRenta.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        </tr>
                                        <tr className="cf-total">
                                            <td>Total</td>
                                            <td>{calculosProductos().total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        </tr>
                                        {documentosFisico.monto && <tr className="cf-total" style={{opacity: 0.5}}>
                                            <td>Total original</td>
                                            <td>${convertirNumeroConComas(documentosFisico.monto)}</td>
                                        </tr>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </BasicCardDocumentos>
                </div>
                <div className="w-layout-layout bill-section wf-layout-layout">
                    <div></div>
                    <DocumentosReceptor />
                </div>
            </div>
        </div>
      </>
    )
}